const Eyeopen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2056_26496)">
        <path
          d="M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z"
          fill="#7E7E7E"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2056_26496">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

const Eyeclose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M9.99999 13.0001C7.62968 13.0001 5.71093 11.1654 5.53437 8.84039L2.25624 6.30696C1.82531 6.84758 1.42874 7.41914 1.10874 8.04414C1.03726 8.18555 1.00001 8.34179 1.00001 8.50024C1.00001 8.65869 1.03726 8.81492 1.10874 8.95633C2.80343 12.2629 6.15843 14.5001 9.99999 14.5001C10.8409 14.5001 11.6522 14.3751 12.4341 14.1732L10.8125 12.9185C10.5447 12.9703 10.2727 12.9976 9.99999 13.0001ZM19.8069 14.8157L16.3522 12.1457C17.4016 11.2613 18.2647 10.177 18.8912 8.95602C18.9627 8.81461 19 8.65838 19 8.49993C19 8.34147 18.9627 8.18524 18.8912 8.04383C17.1966 4.73727 13.8416 2.50008 9.99999 2.50008C8.39109 2.50203 6.80831 2.90707 5.39624 3.67821L1.42062 0.605395C1.36878 0.565053 1.30949 0.535323 1.24615 0.517902C1.18282 0.500482 1.11667 0.495713 1.05149 0.503868C0.986304 0.512023 0.923369 0.532942 0.866275 0.56543C0.809182 0.597917 0.75905 0.641337 0.718743 0.693207L0.105306 1.48289C0.0239305 1.58758 -0.0125333 1.7203 0.0039342 1.85186C0.0204017 1.98342 0.088452 2.10306 0.193118 2.18446L18.5794 16.3948C18.6312 16.4351 18.6905 16.4648 18.7538 16.4823C18.8172 16.4997 18.8833 16.5045 18.9485 16.4963C19.0137 16.4881 19.0766 16.4672 19.1337 16.4347C19.1908 16.4022 19.2409 16.3588 19.2812 16.307L19.895 15.5173C19.9763 15.4125 20.0127 15.2798 19.9962 15.1482C19.9797 15.0167 19.9116 14.8971 19.8069 14.8157ZM14.0656 10.3782L12.8375 9.42883C12.9409 9.12992 12.9958 8.81636 13 8.50008C13.0061 8.03704 12.9035 7.57902 12.7005 7.16281C12.4975 6.74661 12.1996 6.38382 11.831 6.10359C11.4623 5.82336 11.0331 5.63349 10.5777 5.54925C10.1223 5.46501 9.65358 5.48873 9.20906 5.61852C9.3975 5.87386 9.49943 6.18273 9.49999 6.50008C9.49533 6.60569 9.47919 6.71047 9.45187 6.81258L7.15156 5.03477C7.95061 4.36702 8.95866 4.00085 9.99999 4.00008C10.591 3.99975 11.1763 4.11592 11.7225 4.34195C12.2686 4.56798 12.7648 4.89944 13.1827 5.31737C13.6006 5.7353 13.9321 6.2315 14.1581 6.77762C14.3841 7.32373 14.5003 7.90904 14.5 8.50008C14.5 9.17602 14.3347 9.80602 14.0656 10.3785V10.3782Z"
        fill="#828282"
      />
    </svg>
  );
};

const Dashboardsvg = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V7.76166C2.49995 7.63578 2.52842 7.51153 2.58326 7.39823C2.63811 7.28493 2.71791 7.18553 2.81667 7.10749L9.48333 1.84832C9.63046 1.73206 9.81249 1.66882 10 1.66882C10.1875 1.66882 10.3695 1.73206 10.5167 1.84832L17.1833 7.10666C17.2822 7.18478 17.3621 7.28432 17.4169 7.39777C17.4718 7.51123 17.5002 7.63564 17.5 7.76166V16.6667ZM5.83333 9.99999C5.83333 11.1051 6.27232 12.1649 7.05372 12.9463C7.83512 13.7277 8.89493 14.1667 10 14.1667C11.1051 14.1667 12.1649 13.7277 12.9463 12.9463C13.7277 12.1649 14.1667 11.1051 14.1667 9.99999H12.5C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 9.99999H5.83333Z"
        fill="black" />
    </svg>
  );
};




const Userssvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
        fill="#323232"
      />
      <path
        d="M15.6309 7.15517C15.9015 7.05482 16.1943 7 16.4999 7C17.8806 7 18.9999 8.11929 18.9999 9.5C18.9999 10.8807 17.8806 12 16.4999 12C16.1943 12 15.9015 11.9452 15.6309 11.8448"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M3 19C3.69137 16.6928 5.46998 16 9.5 16C13.53 16 15.3086 16.6928 16 19"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M17 15C19.403 15.095 20.5292 15.6383 21 17"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
        stroke="#323232"
        strokeWidth={2}
      />
    </svg>
  );
};

const QuickMessagesvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);


const Enquirysvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14C20 15.1046 19.1046 16 18 16H9L5 19.5V16H6C4.89543 16 4 15.1046 4 14V6Z"
        fill="#323232"
      />
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14C20 15.1046 19.1046 16 18 16H9L5 19.5V16H6C4.89543 16 4 15.1046 4 14V6Z"
        stroke="#323232"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M10.5 9.5C10.5 8.5 11.2 8 12 8C12.8 8 13.5 8.5 13.5 9.3C13.5 10 13 10.3 12.4 10.7C12 11 12 11.3 12 11.7"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="13.5" r="0.9" fill="#323232" />
    </svg>
  );
};


const Templatesvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="14" y2="17" />
  </svg>
);

const Adminsvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const Watersvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12c1.5-2 3.5-2 5 0s3.5 2 5 0 3.5-2 5 0 3.5 2 5 0" />
    <path d="M2 18c1.5-2 3.5-2 5 0s3.5 2 5 0 3.5-2 5 0 3.5 2 5 0" />
    <path d="M2 6c1.5-2 3.5-2 5 0s3.5 2 5 0 3.5-2 5 0 3.5 2 5 0" />
  </svg>
);

const Catchsvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12s-3-6-9-6-9 6-9 6 3 6 9 6 9-6 9-6Z" />
    <path d="M2 12s3-6 9-6 9 6 9 6" />
    <circle cx="16" cy="11" r="0.5" fill="currentColor" />
  </svg>
);

const Rulessvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <path d="M8 7h8" />
    <path d="M8 11h6" />
  </svg>
);
const Trophy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="1.8"
    stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 21h8" />
    <path d="M12 17v4" />
    <path d="M7 4h10v5a5 5 0 0 1-10 0V4z" />
    <path d="M7 6H5a2 2 0 0 0 2 4" />
    <path d="M17 6h2a2 2 0 0 1-2 4" />
  </svg>
);

const Archivesvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="5" rx="1" />
    <path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" />
    <line x1="10" y1="14" x2="14" y2="14" />
  </svg>
);

const Newslettersvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
    <path d="M18 14h-8" />
    <path d="M15 18h-5" />
    <path d="M10 6h8v4h-8V6Z" />
  </svg>
);
const Mapsvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
);

const Incidentsvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const Vehiclesvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 17h14M5 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm14 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM5 17V9l2-5h10l2 5v8" />
    <path d="M3 12h18" />
  </svg>
);
const Fishsvg = () => (

  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.41667 10C6.20001 7.11667 9.53334 5 12.5 5C15.4667 5 17.55 7.11667 18.3333 10C17.55 12.8917 15.4667 15 12.5 15C9.53334 15 6.20001 12.8917 5.41667 10Z" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15 10V10.4167" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.3333 14.9417C12.2493 13.5223 11.6621 11.786 11.6621 10C11.6621 8.21408 12.2493 6.47769 13.3333 5.05835" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83333 8.89171C5.83333 6.66671 4.64999 4.97504 2.27499 4.58337C1.44166 5.83337 1.44166 8.75004 2.46666 10C1.43333 11.25 1.43333 14.1667 2.27499 15.4167C4.64999 15.025 5.83333 13.3334 5.83333 11.1084" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.71667 6.05001C8.50001 4.90001 7.64167 3.53334 6.66667 2.50001H11.5C11.8954 2.49855 12.2785 2.63771 12.5807 2.89265C12.883 3.14759 13.0848 3.50168 13.15 3.89168L13.3417 5.05835" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.3417 14.9417L13.15 16.1083C13.0848 16.4983 12.883 16.8524 12.5807 17.1074C12.2785 17.3623 11.8954 17.5015 11.5 17.5H7.91667C8.72405 16.5846 9.16606 15.4039 9.15834 14.1833" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

);

const FishsvgGreen = () => (

  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.41667 10C6.20001 7.11667 9.53334 5 12.5 5C15.4667 5 17.55 7.11667 18.3333 10C17.55 12.8917 15.4667 15 12.5 15C9.53334 15 6.20001 12.8917 5.41667 10Z" stroke="#298E6D" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15 10V10.4167" stroke="#298E6D" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.3333 14.9417C12.2493 13.5223 11.6621 11.786 11.6621 10C11.6621 8.21408 12.2493 6.47769 13.3333 5.05835" stroke="#298E6D" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83333 8.89171C5.83333 6.66671 4.64999 4.97504 2.27499 4.58337C1.44166 5.83337 1.44166 8.75004 2.46666 10C1.43333 11.25 1.43333 14.1667 2.27499 15.4167C4.64999 15.025 5.83333 13.3334 5.83333 11.1084" stroke="#298E6D" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.71667 6.05001C8.50001 4.90001 7.64167 3.53334 6.66667 2.50001H11.5C11.8954 2.49855 12.2785 2.63771 12.5807 2.89265C12.883 3.14759 13.0848 3.50168 13.15 3.89168L13.3417 5.05835" stroke="#298E6D" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.3417 14.9417L13.15 16.1083C13.0848 16.4983 12.883 16.8524 12.5807 17.1074C12.2785 17.3623 11.8954 17.5015 11.5 17.5H7.91667C8.72405 16.5846 9.16606 15.4039 9.15834 14.1833" stroke="#298E6D" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

);

const ZeroIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="9" y1="9" x2="15" y2="15" />
    <line x1="15" y1="9" x2="9" y2="15" />
  </svg>
);



export {
  Eyeopen,
  Eyeclose,
  Dashboardsvg,
  Userssvg,
  Archivesvg,
  Enquirysvg,
  Templatesvg,
  Adminsvg,
  Watersvg,
  Catchsvg,
  Rulessvg,
  Trophy,
  Newslettersvg,
  QuickMessagesvg,
  Fishsvg,
  Mapsvg,
  Incidentsvg,
  Vehiclesvg,
  ZeroIcon,
  FishsvgGreen
};
